@if (user$ | async; as user) {
  <div class="cx-login-greet" (click)="showMyaccountMenu()">
    <app-custom-icons [type]="iconTypes.USER"></app-custom-icons>
  </div>
  @if (showMenu) {
    <div class="HeaderLinksWrapper" id="headerLoginPopup">
      <div class="close">
        <cx-icon [type]="iconTypes.CLOSE" (click)="showMyaccountMenu()" id="close-button"></cx-icon>
      </div>
      <div class="title">
        {{ 'loginForm.userGreeting' | cxTranslate: {name: user?.consumer ? user?.firstName?.split(' ')[0] :
        user?.contactPerson?.split(' ')[0]} }}
      </div>
      <cx-page-slot position="HeaderLinks"></cx-page-slot>
    </div>
  }
  <cx-generic-link [routerLink]="{ cxRoute: 'myAccountWishlist'} | cxUrl">
    <app-custom-icons [type]="iconTypes.FAV"></app-custom-icons>
  </cx-generic-link>
}